import * as React from 'react';
import Logo from '../Assets/Images/Logo.png';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Alert from './Alert';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import {
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from 'firebase/auth';
import { auth } from '../FirebaseConfig';
import { useSharedState } from '../Hooks/SharedState';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { signInWithEmail } from '../Services/SignInWithEmail';

function Copyright(props) {
  return (
    <Typography
      variant='body2'
      color='text.secondary'
      align='center'
      {...props}
    >
      {'Copyright © '}
      <Link color='inherit' href='https://www.getinfo.net.br'>
        Getinfo Soluções Corporativas
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
const theme = createTheme();

export default function SignIn() {
  const { rawData, setRawData } = useSharedState();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setRawData((prev) => ({ ...prev, userOrPassIsWrong: false }));
    const data = new FormData(event.currentTarget);
    const email = data.get('email');
    const password = data.get('password');
    try {
      // Persistência: se checkbox "remember" estiver marcado, usa local; senão, session
      const remember = data.get('remember') === 'on';
      await setPersistence(
        auth,
        remember ? browserLocalPersistence : browserSessionPersistence
      );
      await signInWithEmail(email, password);
      // SPA navigate para melhor UX
      navigate('/audith', { replace: true });
    } catch (_e) {
      setRawData((prevState) => ({
        ...prevState,
        userOrPassIsWrong: true,
      }));
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component='main' maxWidth='xs'>
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <img
            src={Logo}
            alt='Logo getinfo sistemas'
            style={{ width: '266px', height: '86px' }}
          />
          <Avatar sx={{ m: 1, bgcolor: '#595454' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component='h1' variant='h5'>
            Acesso ao Sistema
          </Typography>
          {rawData.userOrPassIsWrong ? (
            <Alert message={'Usuario Ou Senha Invalidos'} />
          ) : (
            ''
          )}
          <Box
            component='form'
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin='normal'
              required
              fullWidth
              id='email'
              label='Email'
              name='email'
              autoComplete='email'
              autoFocus
            />
            <TextField
              margin='normal'
              required
              fullWidth
              name='password'
              label='Senha'
              type='password'
              id='password'
              autoComplete='current-password'
            />
            <FormControlLabel
              control={<Checkbox name='remember' value='on' color='primary' />}
              label='Lembrar Senha'
            />
            <Button
              type='submit'
              fullWidth
              variant='contained'
              sx={{ mt: 3, mb: 2, backgroundColor: '#595454' }}
            >
              Logar
            </Button>
            <Box sx={{ textAlign: 'center', mt: 2 }}>
              <Link
                component='button'
                variant='body2'
                onClick={() => navigate('/forgot-password')}
                sx={{
                  textDecoration: 'none',
                  color: 'primary.main',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Esqueceu a senha?
              </Link>
            </Box>
          </Box>
        </Box>
        <Copyright sx={{ mt: 8, mb: 4 }} />
      </Container>
    </ThemeProvider>
  );
}
